/* Other Imports */
import "./assets/style.css";
import "./theme/default.styl";

/* Vue Imports */
import Vue from "vue";
import "@fortawesome/fontawesome-free/css/all.css";
import "@mdi/font/css/materialdesignicons.css";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import Vuetify from "vuetify";
import VueCarousel from "vue-carousel";
import VueCroppie from "vue-croppie";
import store from "../src/Store/store";
import { axiosInterceptorSetup } from "./Utility/AxiosInterceptor";
import * as filters from "./Filters/Humanizer";

import VueHtmlToPaper from "vue-html-to-paper";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};
import Element from "element-ui";
import "./registerServiceWorker";

Vue.use(Element);
Vue.use(VueHtmlToPaper, options);
Vue.use(VueCroppie);
Vue.use(VueCarousel);
Vue.use(Vuetify, {
  iconfont: "fa"
});

Vue.use(Vuetify, {
  iconfont: "mdi"
});
Vue.config.productionTip = false;
axiosInterceptorSetup();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
